export default __webpack_public_path__ + "car.bb4d9413.svg";